'use client';
import React from 'react';

import Hooks from '@benzinga/hooks';
import { SessionContext } from '@benzinga/session-context';
import { SubscriptionsManager, SubscriptionsManagerEvent } from '@benzinga/subscription-manager';

/**
 * Hook to check if a user has a subscription or not
 */
export const useUserHasSubscription = (slug: string): boolean | undefined => {
  const session = React.useContext(SessionContext);
  const subscriptionManager = session.getManager(SubscriptionsManager);
  const [hasSubscription, setHasSubscription] = React.useState(() => subscriptionManager.hasSubscription(slug));

  Hooks.useSubscriber(subscriptionManager, (event: SubscriptionsManagerEvent) => {
    switch (event.type) {
      case 'subscription:user_subscriptions_changed':
        setHasSubscription(subscriptionManager.hasSubscription(slug));
        break;
    }
  });

  return hasSubscription;
};
